// src/utils/fetchBookDetail.ts
// 新 BIB_SIMPLE API を使って書誌情報を取得

import axios from 'axios';
import { buildBibSimpleUrl } from '../config/api';
import { BibSimpleResponse } from '../types/rlTypes';

export const fetchBibSimple = async (rlBookId: number): Promise<BibSimpleResponse | null> => {
  try {
    const response = await axios.get(buildBibSimpleUrl(rlBookId));
    return response.data as BibSimpleResponse;
  } catch (error) {
    console.error('Failed to fetch bib simple:', error);
    return null;
  }
};
